import { nodeExerciseRoute } from "../skill-state.js";

export function nodeToDrillRoute(nodeId: string): string {
  const route = nodeExerciseRoute(nodeId);
  if (!route) return "/exercise";
  return `${route.path}?mode=listen&nodeId=${nodeId}`;
}

export function shuffled<T>(arr: T[]): T[] {
  const result = [...arr];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = result[i]!;
    result[i] = result[j]!;
    result[j] = tmp;
  }
  return result;
}
